var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emc-chart-apex-base", {
    attrs: {
      series: _vm.series,
      type: "line",
      options: _vm.chartOptions,
      loading: _vm.loading,
    },
    on: {
      "update:loading": function ($event) {
        _vm.loading = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "actions",
        fn: function () {
          return [
            _c("emc-chart-filter", {
              attrs: { show: _vm.showFilter },
              on: {
                "update:show": function ($event) {
                  _vm.showFilter = $event
                },
                filter: function ($event) {
                  return _vm.filter($event)
                },
              },
            }),
            _c("emc-chart-refresh-status", {
              attrs: {
                label: _vm.statusLabel,
                failed: _vm.hasFailed,
                "error-code": _vm.errorCode,
              },
            }),
            _c("v-spacer"),
            _c(
              "v-tooltip",
              {
                attrs: { bottom: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: { color: "primary", icon: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.showFilter = true
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("v-icon", { attrs: { btn: "" } }, [
                              _vm._v("mdi-filter-outline"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [_c("span", [_vm._v(" Selecionar Categorias ")])]
            ),
            _c("emc-button-icon", {
              attrs: {
                "btn-small": "",
                disabled: _vm.isBusy,
                icon: "mdi-refresh-circle",
                text: _vm.updated_at || `Atualizar`,
                color: "success",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.start()
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }